
// import React, { useState, useEffect, useCallback } from 'react';
// import './AddBrand.css';

// const AddBrand = () => {
//   const [brandName, setBrandName] = useState('');
//   const [brandCode, setBrandCode] = useState('');
//   const [status, setStatus] = useState('ACTIVE');
//   const [logo, setLogo] = useState(null);
//   const [previewUrl, setPreviewUrl] = useState(null);

//   const [brands, setBrands] = useState([]);
//   const [listLoading, setListLoading] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const [message, setMessage] = useState({ type: '', text: '' });

//   const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:8000";

//   // Fetch Brands from backend API
//   const fetchBrands = useCallback(async () => {
//     const storedUser = localStorage.getItem("user");
//     const user = storedUser ? JSON.parse(storedUser) : null;

//     if (!user?.id) return;

//     setListLoading(true);
//     try {
//       const response = await fetch(`${API_BASE_URL}/api/brands`, {
//         method: 'GET',
//         headers: {
//           'X-User-Id': String(user.id)
//         }
//       });

//       const data = await response.json();

//       if (response.ok) {
//         // Normalize response whether it returns a direct array or object with a key
//         if (Array.isArray(data)) {
//           setBrands(data);
//         } else if (Array.isArray(data.brands)) {
//           setBrands(data.brands);
//         } else if (Array.isArray(data.data)) {
//           setBrands(data.data);
//         } else {
//           setBrands([]);
//         }
//       } else {
//         console.error('Failed to fetch brands list:', data);
//       }
//     } catch (error) {
//       console.error('Error fetching brands:', error);
//     } finally {
//       setListLoading(false);
//     }
//   }, [API_BASE_URL]);

//   useEffect(() => {
//     fetchBrands();
//   }, [fetchBrands]);

//   // Handle logo file selection and preview
//   const handleLogoChange = (e) => {
//     const file = e.target.files[0];
//     if (file) {
//       setLogo(file);
//       setPreviewUrl(URL.createObjectURL(file));
//     }
//   };

//   // Form submission handler
//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setMessage({ type: '', text: '' });

//     if (!brandName.trim()) {
//       setMessage({
//         type: 'error',
//         text: 'Brand Name is required.'
//       });
//       return;
//     }

//     // Get logged-in user context from localStorage
//     const storedUser = localStorage.getItem("user");
//     const user = storedUser ? JSON.parse(storedUser) : null;

//     if (!user?.id) {
//       setMessage({
//         type: 'error',
//         text: 'User session not found. Please login again.'
//       });
//       return;
//     }

//     setLoading(true);

//     const formData = new FormData();
//     formData.append('brand_name', brandName);

//     if (brandCode) {
//       formData.append('brand_code', brandCode);
//     }

//     formData.append('status', status);

//     if (logo) {
//       formData.append('logo', logo);
//     }

//     try {
//       const response = await fetch(`${API_BASE_URL}/api/brands`, {
//         method: 'POST',
//         headers: {
//           'X-User-Id': String(user.id)
//         },
//         body: formData
//       });

//       const data = await response.json();

//       if (response.ok) {
//         setMessage({
//           type: 'success',
//           text: data.message || 'Brand added successfully!'
//         });

//         // Reset form fields
//         setBrandName('');
//         setBrandCode('');
//         setStatus('ACTIVE');
//         setLogo(null);
//         setPreviewUrl(null);

//         // Refresh brand list dynamically
//         fetchBrands();
//       } else {
//         let errorMessage = 'Failed to add brand. Please try again.';

//         if (Array.isArray(data.detail)) {
//           errorMessage = data.detail
//             .map((error) => error.msg || 'Validation error')
//             .join(', ');
//         } else if (typeof data.detail === 'string') {
//           errorMessage = data.detail;
//         } else if (data.detail) {
//           errorMessage = JSON.stringify(data.detail);
//         }

//         setMessage({
//           type: 'error',
//           text: errorMessage
//         });
//       }
//     } catch (error) {
//       console.error('Error submitting form:', error);
//       setMessage({
//         type: 'error',
//         text: 'Network error. Could not connect to server.'
//       });
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="add-brand-container">
//       <div className="card-header">
//         <h2>Add New Brand</h2>
//         <p>Create and register a brand in the Snap4Me system</p>
//       </div>

//       {message.text && (
//         <div className={`alert-box ${message.type}`}>
//           {message.text}
//         </div>
//       )}

//       <form onSubmit={handleSubmit} className="brand-form">
//         <div className="form-group">
//           <label htmlFor="brandName">Brand Name <span className="required">*</span></label>
//           <input
//             id="brandName"
//             type="text"
//             value={brandName}
//             onChange={(e) => setBrandName(e.target.value)}
//             placeholder="e.g. Dabur, Pepsi"
//             required
//           />
//         </div>

//         <div className="form-group">
//           <label htmlFor="brandCode">Brand Code</label>
//           <input
//             id="brandCode"
//             type="text"
//             value={brandCode}
//             onChange={(e) => setBrandCode(e.target.value)}
//             placeholder="e.g. DBR_01"
//           />
//         </div>

//         <div className="form-group">
//           <label htmlFor="status">Status</label>
//           <select
//             id="status"
//             value={status}
//             onChange={(e) => setStatus(e.target.value)}
//           >
//             <option value="ACTIVE">ACTIVE</option>
//             <option value="INACTIVE">INACTIVE</option>
//           </select>
//         </div>

//         <div className="form-group">
//           <label htmlFor="logo">Brand Logo</label>
//           <input
//             id="logo"
//             type="file"
//             accept="image/png, image/jpeg, image/jpg, image/webp, image/svg+xml"
//             onChange={handleLogoChange}
//           />
//           {previewUrl && (
//             <div className="logo-preview">
//               <img src={previewUrl} alt="Logo Preview" />
//             </div>
//           )}
//         </div>

//         <div className="form-actions">
//           <button type="submit" className="submit-btn" disabled={loading}>
//             {loading ? 'Adding Brand...' : 'Save Brand'}
//           </button>
//         </div>
//       </form>

//       {/* Brand List Section */}
//       <div className="brand-list-section" style={{ marginTop: '2.5rem' }}>
//         <div className="card-header">
//           <h2>Registered Brands</h2>
//           <p>Brands registered under your organization</p>
//         </div>

//         {listLoading ? (
//           <p>Loading brands...</p>
//         ) : brands.length === 0 ? (
//           <p>No brands found.</p>
//         ) : (
//           <div className="brand-table-wrapper" style={{ overflowX: 'auto' }}>
//             <table className="brand-table" style={{ width: '100%', borderCollapse: 'collapse', marginTop: '1rem' }}>
//               <thead>
//                 <tr style={{ textAlign: 'left', borderBottom: '2px solid #ccc' }}>
//                   <th style={{ padding: '8px' }}>ID</th>
//                   <th style={{ padding: '8px' }}>Brand Name</th>
//                   <th style={{ padding: '8px' }}>Brand Code</th>
//                   <th style={{ padding: '8px' }}>Status</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {brands.map((brand) => (
//                   <tr key={brand.id || brand.brand_name} style={{ borderBottom: '1px solid #eee' }}>
//                     <td style={{ padding: '8px' }}>{brand.id}</td>
//                     <td style={{ padding: '8px' }}>{brand.brand_name}</td>
//                     <td style={{ padding: '8px' }}>{brand.brand_code || '-'}</td>
//                     <td style={{ padding: '8px' }}>{brand.status}</td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default AddBrand; 

import React, { useState, useEffect, useCallback } from 'react';
import './AddBrand.css';

const AddBrand = () => {
  const [brandName, setBrandName] = useState('');
  const [brandCode, setBrandCode] = useState('');
  const [status, setStatus] = useState('ACTIVE');
  const [logo, setLogo] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);

  const [brands, setBrands] = useState([]);
  const [listLoading, setListLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({ type: '', text: '' });

  const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:8000";

  // Fetch Brands from backend API
  const fetchBrands = useCallback(async () => {
    const storedUser = localStorage.getItem("user");
    const user = storedUser ? JSON.parse(storedUser) : null;

    if (!user?.id) return;

    setListLoading(true);
    try {
      const response = await fetch(`${API_BASE_URL}/api/brands`, {
        method: 'GET',
        headers: {
          'X-User-Id': String(user.id)
        }
      });

      const data = await response.json();

      if (response.ok) {
        if (Array.isArray(data)) {
          setBrands(data);
        } else if (Array.isArray(data.brands)) {
          setBrands(data.brands);
        } else if (Array.isArray(data.data)) {
          setBrands(data.data);
        } else {
          setBrands([]);
        }
      } else {
        console.error('Failed to fetch brands list:', data);
      }
    } catch (error) {
      console.error('Error fetching brands:', error);
    } finally {
      setListLoading(false);
    }
  }, [API_BASE_URL]);

  useEffect(() => {
    fetchBrands();
  }, [fetchBrands]);

  // Handle logo file selection and preview
  const handleLogoChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setLogo(file);
      setPreviewUrl(URL.createObjectURL(file));
    }
  };

  // Form submission handler
  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage({ type: '', text: '' });

    if (!brandName.trim()) {
      setMessage({
        type: 'error',
        text: 'Brand Name is required.'
      });
      return;
    }

    const storedUser = localStorage.getItem("user");
    const user = storedUser ? JSON.parse(storedUser) : null;

    if (!user?.id) {
      setMessage({
        type: 'error',
        text: 'User session not found. Please login again.'
      });
      return;
    }

    setLoading(true);

    const formData = new FormData();
    formData.append('brand_name', brandName);

    if (brandCode) {
      formData.append('brand_code', brandCode);
    }

    formData.append('status', status);

    if (logo) {
      formData.append('logo', logo);
    }

    try {
      const response = await fetch(`${API_BASE_URL}/api/brands`, {
        method: 'POST',
        headers: {
          'X-User-Id': String(user.id)
        },
        body: formData
      });

      const data = await response.json();

      if (response.ok) {
        setMessage({
          type: 'success',
          text: data.message || 'Brand added successfully!'
        });

        // Reset form fields
        setBrandName('');
        setBrandCode('');
        setStatus('ACTIVE');
        setLogo(null);
        setPreviewUrl(null);

        // Refresh brand list dynamically
        fetchBrands();
      } else {
        let errorMessage = 'Failed to add brand. Please try again.';

        if (Array.isArray(data.detail)) {
          errorMessage = data.detail
            .map((error) => error.msg || 'Validation error')
            .join(', ');
        } else if (typeof data.detail === 'string') {
          errorMessage = data.detail;
        } else if (data.detail) {
          errorMessage = JSON.stringify(data.detail);
        }

        setMessage({
          type: 'error',
          text: errorMessage
        });
      }
    } catch (error) {
      console.error('Error submitting form:', error);
      setMessage({
        type: 'error',
        text: 'Network error. Could not connect to server.'
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="add-brand-container">
      <div className="card-header">
        <h2>Add New Brand</h2>
        <p>Create and register a brand in the Snap4Me system</p>
      </div>

      {message.text && (
        <div className={`alert-box ${message.type}`}>
          {message.text}
        </div>
      )}

      <form onSubmit={handleSubmit} className="brand-form">
        <div className="form-group">
          <label htmlFor="brandName">Brand Name <span className="required">*</span></label>
          <input
            id="brandName"
            type="text"
            value={brandName}
            onChange={(e) => setBrandName(e.target.value)}
            placeholder="e.g. Dabur, Pepsi"
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="brandCode">Brand Code</label>
          <input
            id="brandCode"
            type="text"
            value={brandCode}
            onChange={(e) => setBrandCode(e.target.value)}
            placeholder="e.g. DBR_01"
          />
        </div>

        <div className="form-group">
          <label htmlFor="status">Status</label>
          <select
            id="status"
            value={status}
            onChange={(e) => setStatus(e.target.value)}
          >
            <option value="ACTIVE">ACTIVE</option>
            <option value="INACTIVE">INACTIVE</option>
          </select>
        </div>

        <div className="form-group">
          <label htmlFor="logo">Brand Logo</label>
          <input
            id="logo"
            type="file"
            accept="image/png, image/jpeg, image/jpg, image/webp, image/svg+xml"
            onChange={handleLogoChange}
          />
          {previewUrl && (
            <div className="logo-preview">
              <img src={previewUrl} alt="Logo Preview" />
            </div>
          )}
        </div>

        <div className="form-actions">
          <button type="submit" className="submit-btn" disabled={loading}>
            {loading ? 'Adding Brand...' : 'Save Brand'}
          </button>
        </div>
      </form>

      {/* Brand List Section */}
      <div className="brand-list-section">
        <div className="card-header">
          <h2>Registered Brands</h2>
          <p>Brands registered under your organization</p>
        </div>

        {listLoading ? (
          <p className="brand-list-empty">Loading brands...</p>
        ) : brands.length === 0 ? (
          <p className="brand-list-empty">No brands found.</p>
        ) : (
          <div className="brand-table-wrapper">
            <table className="brand-table">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Brand Name</th>
                  <th>Brand Code</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {brands.map((brand) => (
                  <tr key={brand.id || brand.brand_name}>
                    <td>{brand.id}</td>
                    <td>{brand.brand_name || brand.name}</td>
                    <td>{brand.brand_code || '-'}</td>
                    <td>
                      <span className={`status-pill ${String(brand.status).toLowerCase()}`}>
                        {brand.status}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default AddBrand;